var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-gray-500 font-bold pt-56"},[_vm._v(" Signing you out.. ")])}
var staticRenderFns = []

export { render, staticRenderFns }